import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "horizontal-bar-chart-icon",
  "use": "horizontal-bar-chart-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"horizontal-bar-chart-icon\">\n  <path fill=\"#677078\" d=\"M5,9 L8,9 L8,20 L5,20 L5,9 Z M10.6,4 L13.4,4 L13.4,20 L10.6,20 L10.6,4 Z M16.2,13.1428571 L19,13.1428571 L19,20 L16.2,20 L16.2,13.1428571 Z\" transform=\"rotate(90 12 12)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol